import React, { useState, useEffect } from "react";
import eye_icon from "../../assets/icons/common/Eye.svg";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { Col } from "react-bootstrap";
import Header from "../../component/Header/Header";
import { api } from "../../constants/Services";
import { PaginationControl } from "react-bootstrap-pagination-control";

function MaterialIssueList() {
  const [selectedProject, setSelectedProject] = useState("");
  const [MiList, setMiList] = useState([]);
  const [projectList, setProjectList] = useState([]);
  const [page, setPage] = useState(1);
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();

  const getProjects = () => {
    api.project_list().then((res) => {
      setProjectList(res?.projects);
    });
  };
  useEffect(() => {
    getProjects();
  }, []);

  useEffect(()=>{
    if(searchParams?.get("projectID")){
      setSelectedProject(searchParams?.get("projectID"))
      getList(searchParams?.get("projectID"),1);
    }
  },[searchParams?.get("projectID")]);

  // useEffect(() => {
  //   if (searchParams?.get("projectID")) {
  //     setSelectedProject(searchParams?.get("projectID"))
  //     getList(searchParams?.get("projectID"),1);
  //   } 

  // }, [searchParams?.get("projectID")]);

  const getList = (id, page) => {
    let obj = {
      project_id: id,
    };
    let param = `?page=${page}`;
    api
      .matertialIssueList(param, obj)
      .then((res) => {
        // console.log("getList", res);
        let temp = [];
        res?.material_issues?.map((item, ind) => {
          item?.material_issue_detail?.map((mat, indx) => {
            let obj = {
              ...mat,
              ...item,
            };

            delete obj?.material_issue_detail;
            temp.push(obj);
          });
        });
        // console.log("temp", temp);
        setMiList({ material_issues: temp, pagination: res?.pagination });
      })
      .catch((err) => {
        console.log("err", err);
      });
  };

  const materialTransferDetailHandler = (sel_mt, mt_colde, mt_date) => {
    navigate("/ism/output", {
      state: { id: sel_mt },
    });
  };

  // console.log("MiList", MiList);

  return (
    <Col xs={12} className="py-2 px-1 p-md-3">
      <Header />
      <Col className="emply-master-form px-3 py-2 py-md-4 bg-white my-3 text-center">
        <header>
          <Col xs={12} className="d-flex my-2">
            <select
              style={{ minHeight: "2.1rem" }}
              className="border-0 bg-lightBlue px-2 py-1 w-90 mt-1 ms-auto pointer"
              value={selectedProject}
              onChange={(e) => {
                setSelectedProject(e.target.value);
                getList(e.target.value, 1);
                setPage(1);
              }}
            >
              <option>Select Project</option>
              {projectList?.map((project) => (
                <option key={project?.id} value={project?.id}>
                  {project?.name}
                </option>
              ))}
            </select>
          </Col>
        </header>
        <h4 className="my-1 py-1">Material Issue List</h4>
        <div className="user-mange-table " style={{ overflowX: "scroll" }}>
          <table>
            <thead>
              <tr>
                <th>S.No</th>
                <th className="text-nowrap">Material Issue No.</th>
                <th className="text-nowrap">Material Code</th>
                {/* <th className="text-nowrap">Material Description</th> */}
                <th>UOM</th>
                <th className="text-nowrap">Ware House</th>
                <th className="text-nowrap">Cumulative QTY</th>
                <th className="text-nowrap">Issued Qty</th>

                <th className="text-nowrap">Created By</th>
                <th>Status</th>
                <th>Action</th>
              </tr>
            </thead>
            <tbody>
              {MiList?.material_issues?.length > 0 &&
                MiList?.material_issues?.map((material, ind) => (
                  <tr>
                    <td>{ind + 1}</td>
                    <td style={{ fontSize: "12px" }}>{material?.issue_no}</td>
                    <td style={{ fontSize: "12px" }}>{material?.material?.material_code}</td>
                    {/* <td style={{fontSize:"12px"}}>{material?.material?.name}</td> */}
                    <td style={{ fontSize: "12px" }}>{material?.material?.uom}</td>
                    <td style={{ fontSize: "12px" }}>{material?.warehouse?.name}</td>
                    <td style={{ fontSize: "12px" }}>{material?.stock_qty}</td>
                    <td style={{ fontSize: "12px" }}>{material?.issued_qty}</td>

                    <td style={{ fontSize: "12px" }}>{material?.employee?.name}</td>
                    <td style={{ fontSize: "12px" }}>
                      {" "}
                      {material?.status == 1
                        ? "Pending"
                        : material?.status == 2
                          ? "Accepted"
                          : "Rejected"}
                    </td>
                    <td style={{ fontSize: "12px" }}>
                      <div className="d-flex">
                        <Link to={`/ism/output?id=${material?.id
                          }&projectID=${+selectedProject}`}
                        >
                          <img
                            onClick={() =>
                              materialTransferDetailHandler(
                                material?.id,
                                material?.po_no,
                                material?.po_date
                              )
                            }
                            style={{ width: "20px" }}
                            className="pointer ms-2"
                            src={eye_icon}
                            alt="eye-icon"
                          />
                        </Link>
                      </div>
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>
        <div className="my-1 py-1 d-flex justify-content-end">
          <PaginationControl
            page={page}
            between={4}
            total={MiList?.pagination?.total}
            limit={10}
            changePage={(page) => {
              setPage(page);
              getList(selectedProject, page);
              console.log(page);
            }}
            ellipsis={1}
          />
        </div>
      </Col>
    </Col>
  );
}

export default MaterialIssueList;
